/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppVersionUpdate
 */
export interface AppVersionUpdate {
    /**
     * 
     * @type {Array<number>}
     * @memberof AppVersionUpdate
     */
    notification_days?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppVersionUpdate
     */
    required: boolean;
    /**
     * 
     * @type {number}
     * @memberof AppVersionUpdate
     */
    rollout_timestamp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AppVersionUpdate
     */
    version: number;
    /**
     * 
     * @type {boolean}
     * @memberof AppVersionUpdate
     */
    go_live: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppVersionUpdate
     */
    update_complete: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppVersionUpdate
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof AppVersionUpdate
     */
    id: string;
}

/**
 * Check if a given object implements the AppVersionUpdate interface.
 */
export function instanceOfAppVersionUpdate(value: object): value is AppVersionUpdate {
    if (!('required' in value) || value['required'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('go_live' in value) || value['go_live'] === undefined) return false;
    if (!('update_complete' in value) || value['update_complete'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function AppVersionUpdateFromJSON(json: any): AppVersionUpdate {
    return AppVersionUpdateFromJSONTyped(json, false);
}

export function AppVersionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppVersionUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'notification_days': json['notification_days'] == null ? undefined : json['notification_days'],
        'required': json['required'],
        'rollout_timestamp': json['rollout_timestamp'] == null ? undefined : json['rollout_timestamp'],
        'version': json['version'],
        'go_live': json['go_live'],
        'update_complete': json['update_complete'],
        'object_type': json['object_type'],
        'id': json['id'],
    };
}

export function AppVersionUpdateToJSON(json: any): AppVersionUpdate {
    return AppVersionUpdateToJSONTyped(json, false);
}

export function AppVersionUpdateToJSONTyped(value?: AppVersionUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notification_days': value['notification_days'],
        'required': value['required'],
        'rollout_timestamp': value['rollout_timestamp'],
        'version': value['version'],
        'go_live': value['go_live'],
        'update_complete': value['update_complete'],
        'object_type': value['object_type'],
        'id': value['id'],
    };
}

